import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { chatClient } from "@core/clients";
import { OrderChatUnreadSummary } from "@core/types";
import { orderChatQueryKeys } from "./keys";

const UNREAD_SUMMARY_STALE_TIME_MS = 60_000;

const useChatsUnreadSummaryQuery = (customerId: number | undefined, options?: UseQueryOptions<OrderChatUnreadSummary>) =>
  useQuery<OrderChatUnreadSummary>({
    queryKey: orderChatQueryKeys.unreadSummary(customerId ?? 0),
    queryFn: () => chatClient.getUnreadSummary(),
    enabled: !!customerId,
    staleTime: UNREAD_SUMMARY_STALE_TIME_MS,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    ...options,
  });

export default useChatsUnreadSummaryQuery;
